import React, { Fragment } from 'react'
import { debounce } from 'debounce'
import cx from 'classnames'

import { ToolTip, Input } from '@driftt/tide-core'

import './style.css'

const DEBOUNCE_TIME_IN_MS = 500

const descriptionText = (isUnique, isValid, createOrgError, verifyEmailError) => {
  if (!isValid || createOrgError === 'One or more constraint violations found') {
    return 'Whoops, make sure you’ve entered a valid email!'
  } else if (!isUnique || (createOrgError && createOrgError.endsWith('has already been used'))) {
    return 'This email is already being used for another Drift account!'
  } else if (verifyEmailError) {
    return 'We ran into an issue creating your account. Please try again!'
  }

  return undefined
}

const EmailInput = ({
  placeholder,
  size,
  value,
  onChange,
  personal,
  unique,
  valid,
  label,
  disabled,
  type,
  createOrgError,
  verifyEmailError,
  hideError,
  className,
  shouldAutofocus = true,
}) => {
  const debounceSetEmailAddress = event => debounce(onChange(event), DEBOUNCE_TIME_IN_MS)
  return (
    <Fragment>
      <ToolTip
        open={personal}
        hover={personal}
        flow="up"
        render={() => 'We recommend using a work email in order to get the most out of Drift'}
      />
      <Input
        size={size}
        placeholder={placeholder}
        label={label}
        value={value}
        disabled={disabled}
        type={type}
        className={cx(`${className}`, 'email-input')}
        onChange={debounceSetEmailAddress}
        description={!!value && !hideError && descriptionText(unique, valid, createOrgError, verifyEmailError)}
        autoFocus={shouldAutofocus}
      />
    </Fragment>
  )
}

export default EmailInput
